import {
  AppBar,
  Box,
  Button,
  Container,
  Link,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";

export default function PrivacyPolicyPage() {
  return (
    <Box sx={{ bgcolor: "background.default", minHeight: "100vh" }}>
      <AppBar position="sticky" color="inherit" elevation={1}>
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            height: "80px",
          }}
        >
          <Stack direction="row" spacing={2} alignItems="center">
            <Link href="/">
              <img
                src="/assets/icons/logo.png"
                alt="PrestiYA"
                style={{ height: 150 }}
              />
            </Link>
          </Stack>
          <Stack direction="row" spacing={2}>
            <Button
              variant="contained"
              color="primary"
              sx={{ borderRadius: 2 }}
              href="/"
            >
              Solicitar préstamo
            </Button>
          </Stack>
        </Toolbar>
      </AppBar>
      <Container sx={{ py: 5, minHeight: 800 }}>
        <Typography variant="h4" gutterBottom fontWeight="bold">
          Política de Privacidad – PrestiYA
        </Typography>

        <Typography paragraph>
          En <strong>PrestiYA</strong>, respetamos y protegemos la privacidad de
          nuestros usuarios. Esta política explica cómo recopilamos, usamos y
          protegemos la información personal que nos proporcionas.
        </Typography>

        <Typography variant="h6" gutterBottom>
          1. Información que recopilamos
        </Typography>
        <Typography paragraph>
          Recopilamos datos personales como nombre, número de identificación,
          correo electrónico (
          <a href="mailto:contacto@prestiya.co">contacto@prestiya.co</a>),
          número de teléfono, historial crediticio y demás información necesaria
          para el análisis de solicitudes de crédito.
        </Typography>

        <Typography variant="h6" gutterBottom>
          2. Uso de la información
        </Typography>
        <Typography paragraph>
          Utilizamos tu información para procesar solicitudes de préstamos,
          realizar verificaciones de identidad, cumplir con obligaciones
          legales, enviar notificaciones sobre tus productos financieros y
          mejorar nuestros servicios.
        </Typography>

        <Typography variant="h6" gutterBottom>
          3. Protección de datos
        </Typography>
        <Typography paragraph>
          Implementamos medidas de seguridad técnicas, administrativas y
          organizativas para proteger tu información contra accesos no
          autorizados, pérdida o uso indebido.
        </Typography>

        <Typography variant="h6" gutterBottom>
          4. Contacto
        </Typography>
        <Typography paragraph>
          Si tienes dudas sobre esta política, escríbenos a{" "}
          <a href="mailto:contacto@prestiya.co">contacto@prestiya.co</a>.
        </Typography>
      </Container>
      {/* Footer */}
      <Box
        sx={{ bgcolor: "black", color: "white", py: 4, textAlign: "center" }}
      >
        <Stack
          direction="row"
          spacing={3}
          justifyContent="center"
          sx={{ mb: 1 }}
        >
          <Link href="/privacidad" underline="hover" color="primary.light">
            Política de Privacidad
          </Link>
          <Link
            href="/tratamiento-datos"
            underline="hover"
            color="primary.light"
          >
            Política de Tratamiento de Datos
          </Link>
        </Stack>
        <Typography variant="body2">
          © {new Date().getFullYear()} PrestiYA. Todos los derechos reservados.
        </Typography>
      </Box>
    </Box>
  );
}
